var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg079Social(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.19 16.71C19.7092 16.0902 19.9957 15.3086 20 14.5C20 12.567 18.433 11 16.5 11H16.22C17.0447 10.02 17.4979 8.78086 17.5 7.50003C17.5064 4.95501 15.7659 2.73798 13.2921 2.14007C10.8183 1.54216 8.25743 2.71956 7.10081 4.98658C5.94419 7.2536 6.49398 10.0181 8.43 11.67C4.56147 13.1485 2.00457 16.8586 2 21C2 21.5523 2.44772 22 3 22C3.55228 22 4 21.5523 4 21C4 16.5818 7.58172 13 12 13H13.35C12.7514 14.218 12.932 15.6751 13.81 16.71C12.0753 17.6803 11.0005 19.5124 11 21.5C11 22.0523 11.4477 22.5 12 22.5C12.5523 22.5 13 22.0523 13 21.5C13 19.567 14.567 18 16.5 18C18.433 18 20 19.567 20 21.5C20 22.0523 20.4477 22.5 21 22.5C21.5523 22.5 22 22.0523 22 21.5C21.9995 19.5124 20.9247 17.6803 19.19 16.71ZM12 11C10.067 11 8.5 9.43302 8.5 7.50003C8.5 5.56703 10.067 4.00003 12 4.00003C13.933 4.00003 15.5 5.56703 15.5 7.50003C15.5 9.43302 13.933 11 12 11ZM16.5 16C15.6716 16 15 15.3285 15 14.5C15.0055 13.6739 15.6738 13.0055 16.5 13C17.3284 13 18 13.6716 18 14.5C18 15.3285 17.3284 16 16.5 16Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg079Social);
export default __webpack_public_path__ + "static/media/079-social.bd290e2636098c70bf90380db21395da.svg";
export { ForwardRef as ReactComponent };